import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription, distinctUntilChanged, switchMap } from 'rxjs';
import { MapViewDialogLogisticsComponent } from 'src/app/features/map-view/components/map-view-logistics/map-view-dialog-logistics/map-view-dialog-logistics.component';
import { MapViewDialogComponent } from 'src/app/features/map-view/components/map-view-manufacturing/map-view-dialog/map-view-dialog.component';
import { MessageHandler } from '../../handlers/message-handler';
import { GlobalFilter, SupplyMode } from '../../interfaces/global-filter-model';
import { MondelezDataService } from '../../services/mondelez-data.service';
import { MondelezService } from '../../services/mondelez.service';
import * as L from 'leaflet';
import { GlobalFilterService } from '../../services/global-filter.service';
import { AlertHandler } from 'src/app/core/handlers/alert-handler';
@Component({
  selector: 'app-init-map',
  templateUrl: './init-map.component.html',
  styleUrls: ['./init-map.component.scss'],
})
export class InitMapComponent implements OnInit, OnDestroy {
  public selectedFilters: any;
  @Input() supply_mode: SupplyMode;
  public scenarioId: number;
  public locationData = [];

  private iteration_code: number;
  private subs = new Subscription();
  public map: any;
  @Input() landingPage: boolean;

  constructor(
    private mondelezService: MondelezService,
    private mondelezDataService: MondelezDataService,
    public dialog: MatDialog,
    private globalFilterService: GlobalFilterService
  ) {}

  ngOnInit(): void {
    this.mondelezDataService.updateSupplyMode(this.supply_mode);

    this.subs.add(
      this.mondelezDataService.currentScenarioChanged.subscribe((scenario) => {
        this.scenarioId = scenario.scenario_id;
        this.iteration_code = scenario.iteration_code;
      })
    );

    this.subs.add(
      this.globalFilterService.globalFilters.subscribe((value: GlobalFilter) => {
        if (this.scenarioId && value) {
          this.selectedFilters = value;
          this.initMapView();
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
    this.clearMap();
  }

  public initMapView() {
    const payload = {
      filters: {
        firm_type: this.selectedFilters.firm_type,
        category: this.selectedFilters.category,
        brand: this.selectedFilters.brand,
        manufacturing_network: this.selectedFilters.manufacturing_network,
        start_year: this.selectedFilters.start_year,
        end_year: this.selectedFilters.end_year,
        node_type: this.selectedFilters.node_type,
        node_code: this.selectedFilters.node_code,
        geography: this.selectedFilters.geography,
      },
      supply_mode: this.supply_mode,
      iteration_code: this.iteration_code,
      scenario_id: this.scenarioId,
    };
    this.subs.add(
      this.mondelezService.getMapViewData(payload).subscribe({
        next: (result: any) => {
          if (result && result.response === 'SUCCESS') {
            this.locationData = result.nodes.filter((loc) => loc.latitude && loc.longitude);
            this.clearMap();
            this.map = L.map('country-map', {
              attributionControl: false,
            });
            const validCoordinates = this.locationData.map((city) => [city.latitude, city.longitude]);
            if (validCoordinates.length > 0) {
              this.map.fitBounds(validCoordinates);
            } else {
              this.map.setView([41.8781, -87.6298], 3);
            }
            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(this.map);
            this.addMarkers();
          } else {
            AlertHandler.ErrorAlert(MessageHandler.INTERNAL_ERROR);
          }
        },
      })
    );
  }

  onLocationClick(location) {
    let currentComp, data;
    if (this.supply_mode == SupplyMode.MANUFACTURING) {
      currentComp = MapViewDialogComponent;
      data = location;
    } else {
      currentComp = MapViewDialogLogisticsComponent;
      data = location;
    }
    this.globalFilterService.updateMapViewFiltersSelection({ geography: location.geography, node_code: location.node_code });

    const dialogRef = this.dialog.open(currentComp, {
      width: '95vw',
      height: '90vh',
      disableClose: true,
      data,
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('Map view dialog was closed');
    });
  }

  addMarkers() {
    this.locationData.forEach((location) => {
      let customIcon;
      if (location.node_type === 'Branch') {
        customIcon = L.icon({
          iconUrl: 'assets/images/Ellipse 41.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
        });
      } else if (location.node_type === 'Plant') {
        customIcon = L.icon({
          iconUrl: 'assets/images/Polygon 10.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
        });
      } else if (location.node_type === 'DC') {
        customIcon = L.icon({
          iconUrl: 'assets/images/DC.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
        });
      } else if (location.node_type === 'External') {
        customIcon = L.icon({
          iconUrl: 'assets/images/Rectangle 3808.svg',
          iconSize: [32, 32],
          iconAnchor: [16, 32],
        });
      }

      const marker = L.marker([location.latitude, location.longitude], { icon: customIcon })
        .addTo(this.map)
        // .bindPopup(`<b>${location.node_name}</b><br>${location.address}`) // appear on click
        .on('click', () => {
          // Call the function when the marker is clicked
          if (!this.landingPage) this.onLocationClick(location);
        });
      const tooltipContent = `
      <div style="color: #6C4688; background-color: #F6F6F6; border: 1px solid #6C4688; padding: 5px;">
        <b>${location.location}</b>
      </div>`;
      //   <div style="color: #6C4688; background-color: #F6F6F6; border: 1px solid #6C4688; padding: 5px;">
      //   <b>${location.node_name}</b><br>${location.address}
      // </div>`;
      // (it will appear on hover)
      marker.bindTooltip(tooltipContent, { permanent: false, direction: 'top' });

      marker.on('mouseover', () => {
        marker.openTooltip();
      });

      marker.on('mouseout', () => {
        marker.closeTooltip();
      });
    });
  }

  clearMap() {
    if (this.map) {
      this.map.remove();
    }
  }
}
